<ngx-spinner bdColor="rgb(0,0,0,0.65)" size="default" color="#51DCCE" type="square-loader" [fullScreen]="true">
    <p class="clr-white">Loading...</p>
</ngx-spinner>